module.exports = __webpack_public_path__ + "static/media/logo-alneo.bb35503e.svg";